import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import iconTrash from "../img/icons/icon-trash.svg";
import iconPencil from "../img/icons/icon-pencil.svg";

export default function ProposalTeam(prop) {
    let proposalId = prop.proposalId;
    let member = prop.member;
    let readOnly = prop.readOnly;

    //Team
    let refTeamIdcard = React.useRef();
    let refTeamPrefix = React.useRef();
    let refTeamFirstname = React.useRef();
    let refTeamLastname = React.useRef();
    let refTeamDepartment = React.useRef();
    let refTeamPosition = React.useRef();
    let refTeamProportion = React.useRef();
    let refTeamAddress = React.useRef();
    let refTeamEmail = React.useRef();
    let refTeamPhone = React.useRef();
    let refTeamExpertise = React.useRef();
    let refTeamResponsibility = React.useRef();
    let refTeamHindex = React.useRef();
    let refTeamCitation = React.useRef();
    let [showFormTeam, setShowFormTeam] = React.useState(false);
    let [teamList, setTeamList] = React.useState(null);
    let [teamEditId, setTeamEditId] = React.useState(null);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        (async function() {
            try {
                const teamRes = await getTeamList();
                setTeamList(teamRes);
            } catch (e) {
                //
            }
        })();
    }, []);

    //ProposalTeam
    const onTeamAdd = () => {
        refTeamIdcard.current.value = '';
        refTeamPrefix.current.value = '';
        refTeamFirstname.current.value = '';
        refTeamLastname.current.value = '';
        refTeamDepartment.current.value = '';
        refTeamPosition.current.value = '';
        refTeamProportion.current.value = '';
        refTeamAddress.current.value = '';
        refTeamEmail.current.value = '';
        refTeamPhone.current.value = '';
        refTeamExpertise.current.value = '';
        refTeamResponsibility.current.value = '';
        refTeamHindex.current.value = '';
        refTeamCitation.current.value = '';
        setShowFormTeam(true);
        setTeamEditId(null);
    };

    const onTeamCancel = () => {
        setShowFormTeam(false);
    };

    const onTeamEdit = async (id) => {
        const result = await getTeamListView(id);
        if(result) {
            setTeamEditId(id);
            setShowFormTeam(true);
            refTeamIdcard.current.value = result.idcard;
            refTeamPrefix.current.value = result.prefix;
            refTeamFirstname.current.value = result.firstname;
            refTeamLastname.current.value = result.lastname;
            refTeamDepartment.current.value = result.department;
            refTeamPosition.current.value = result.position;
            refTeamProportion.current.value = result.proportion;
            refTeamAddress.current.value = result.address;
            refTeamEmail.current.value = result.email;
            refTeamPhone.current.value = result.phone;
            refTeamExpertise.current.value = result.expertise;
            refTeamResponsibility.current.value = result.responsibility;
            refTeamHindex.current.value = result.hindex;
            refTeamCitation.current.value = result.citation;
        }
    };

    const onTeamSubmit = () => {
        let idcard = refTeamIdcard.current.value;
        let prefix = refTeamPrefix.current.value;
        let firstname = refTeamFirstname.current.value;
        let lastname = refTeamLastname.current.value;
        let department = refTeamDepartment.current.value;
        let position = refTeamPosition.current.value;
        let proportion = refTeamProportion.current.value;
        let address = refTeamAddress.current.value;
        let email = refTeamEmail.current.value;
        let phone = refTeamPhone.current.value;
        let expertise = refTeamExpertise.current.value;
        let responsibility = refTeamResponsibility.current.value;
        let hindex = refTeamHindex.current.value;
        let citation = refTeamCitation.current.value;

        if(!idcard || isNaN(idcard) || idcard.length !== 13) {
            toast.error(prop.lang === 'en' ? 'Please specify 13-digit Phone number.':'กรุณาระบุ ระบุเลขบัตรประชาชน ตัวเลข 13 หลัก');
            refTeamIdcard.current.focus();
        }
        else if(prefix === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Prefix':'กรุณาระบุ คำนำหน้านาม');
            refTeamPrefix.current.focus();
        }
        else if(firstname === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Firstname':'กรุณาระบุ ชื่อจริง');
            refTeamFirstname.current.focus();
        }
        else if(lastname === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Lastname':'กรุณาระบุ นามสกุล');
            refTeamLastname.current.focus();
        }
        else if(department === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Department':'กรุณาระบุ หน่วยงานที่สังกัด');
            refTeamDepartment.current.focus();
        }
        else if(position === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Position':'กรุณาระบุ ตำแหน่งในโครงการ');
            refTeamPosition.current.focus();
        }
        else if(proportion === '') {
            toast.error(prop.lang === 'en' ? 'Proportion':'สัดส่วนการดำเนิน โครงการวิจัย');
            refTeamProportion.current.focus();
        }
        else if(address === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Address':'กรุณาระบุ ที่อยู่');
            refTeamAddress.current.focus();
        }
        else if(email === '' || !Utils.validateEmail.test(email)) {
            toast.error(prop.lang === 'en' ? 'Please specify a valid email':'กรุณาระบุ รูปแบบอีเมลให้ถูกต้อง');
            refTeamEmail.current.focus();
        }
        else if(!phone || isNaN(phone) || phone.length !== 10) {
            toast.error(prop.lang === 'en' ? 'Please specify 10-digit Phone number.':'กรุณาระบุ ระบุเบอร์โทรศัพท์ ตัวเลข 10 หลัก');
            refTeamPhone.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            let param = {
                                id: teamEditId,
                                proposalId: proposalId,
                                department: department,
                                idcard: idcard,
                                prefix: prefix,
                                firstname: firstname,
                                lastname: lastname,
                                position: position,
                                proportion: proportion,
                                address: address,
                                email: email,
                                phone: phone,
                                expertise: expertise,
                                responsibility: responsibility,
                                hindex: hindex,
                                citation: citation,
                                createdBy: -1,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedBy: -1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await createTeam(param);

                            if(result) {
                                if(result.status === 'success') {

                                    refTeamIdcard.current.value = '';
                                    refTeamPrefix.current.value = '';
                                    refTeamFirstname.current.value = '';
                                    refTeamLastname.current.value = '';
                                    refTeamDepartment.current.value = '';
                                    refTeamPosition.current.value = '';
                                    refTeamProportion.current.value = '';
                                    refTeamAddress.current.value = '';
                                    refTeamEmail.current.value = '';
                                    refTeamPhone.current.value = '';
                                    refTeamExpertise.current.value = '';
                                    refTeamResponsibility.current.value = '';
                                    refTeamHindex.current.value = '';
                                    refTeamCitation.current.value = '';

                                    toast.success(prop.lang === 'en' ? 'Add team successfully.':'บันทึกส่วนข้อมูลคณะผู้วิจัย เรียบร้อย');
                                    setShowFormTeam(false);
                                    const teamRes = await getTeamList();
                                    setTeamList(teamRes);
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onTeamDelete = (id) => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ต้องการบันทึกข้อมูล ?',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        const result = await deleteTeam(id);
                        if(result) {
                            if(result.status === 'success') {
                                toast.success(prop.lang === 'en' ? 'Delete successfully.':'ลบข้อมูล เรียบร้อย');
                                setShowFormTeam(false);
                                const teamRes = await getTeamList();
                                setTeamList(teamRes);
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                        else {
                            toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                        }
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    async function createTeam(param) {
        const response = await fetch(Config.apiUrl +'/proposalTeam/' + (teamEditId ? 'updateTeam':'createTeam'), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getTeamList() {
        const response = await fetch(Config.apiUrl +'/proposalTeam/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                proposalId: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getTeamListView(id) {
        const response = await fetch(Config.apiUrl +'/proposalTeam/viewTeam', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function deleteTeam(id) {
        const response = await fetch(Config.apiUrl +'/proposalTeam/deleteTeam', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="d-flex justify-content-between gap-3">
                <h6 className="pt-1">{prop.lang === 'en' ? 'Details of the research and innovation development team include':'รายละเอียดของคณะผู้วิจัยและพัฒนานวัตกรรม ประกอบด้วย'}</h6>
                {
                    readOnly ? '' : <button className="btn btn-xs btn-light-2" onClick={onTeamAdd}>
                        {prop.lang === 'en' ? '+ Add New':'+ เพิ่มรายชื่อ'}
                    </button>
                }
            </div>
            <div className="table-responsive mt-3">
                <table className="table table-info table-hover text-center" style={{whiteSpace: 'nowrap'}}>
                    <thead>
                    <tr>
                        <th className="text-start">ชื่อ-สกุล</th>
                        <th className="text-start">หน่วยงาน</th>
                        <th className="text-start">ตำแหน่งในโครงการ</th>
                        <th>สัดส่วนการดำเนิน</th>
                        {
                            readOnly ? '' : <th style={{width: '100px'}}>แก้ไข</th>
                        }
                    </tr>
                    </thead>
                    <tbody>
                    {
                        teamList !== null && teamList.count > 0 ?
                            teamList.rows.map((row, index) => {
                                return (
                                    <tr key={index}>
                                        <td className="text-start">{row.prefix + ' ' + row.firstname + ' ' + row.lastname}</td>
                                        <td className="text-start">{row.department}</td>
                                        <td className="text-start">{row.position}</td>
                                        <td>{row.proportion}</td>
                                        {
                                            readOnly ? '' : <td>
                                                <div className="d-flex justify-content-center gap-2">
                                                    <button className="btn btn-trans" onClick={e => onTeamEdit(row.id)}>
                                                        <img className="icons svg-js trash" src={iconPencil} alt="" />
                                                    </button>
                                                    <button className="btn btn-trans" onClick={e => onTeamDelete(row.id)}>
                                                        <img className="icons svg-js trash" src={iconTrash} alt="" />
                                                    </button>
                                                </div>
                                            </td>
                                        }
                                    </tr>
                                )
                            }) : <tr><td colSpan={5}>-</td></tr>
                    }
                    </tbody>
                </table>
            </div>

            <div className={"row g-3 mt-2" + (showFormTeam ? '':' d-none')}>
                <div className="col-md-6">
                    <div className="form-group">
                        <h6>{prop.lang === 'en' ? 'Id Card Number':'เลขบัตรประชาชน 13 หลัก'} <span className="star">*</span></h6>
                        <input type="text" className="form-control" ref={refTeamIdcard} maxLength={13} />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <h6>{prop.lang === 'en' ? 'Prefix':'คำนำหน้า'} <span className="star">*</span></h6>
                        <input type="text" className="form-control" ref={refTeamPrefix} maxLength={250} />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <h6>{prop.lang === 'en' ? 'Firstname':'ชื่อจริง'} <span className="star">*</span></h6>
                        <input type="text" className="form-control" ref={refTeamFirstname} maxLength={250} />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <h6>{prop.lang === 'en' ? 'Lastname':'นามสกุล'} <span className="star">*</span></h6>
                        <input type="text" className="form-control" ref={refTeamLastname} maxLength={250} />
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="form-group">
                        <h6>{prop.lang === 'en' ? 'Department':'หน่วยงาน'} <span className="star">*</span></h6>
                        <input type="text" className="form-control" ref={refTeamDepartment} maxLength={250} />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <h6>{prop.lang === 'en' ? 'Position':'ตำแหน่งในโครงการ'} <span className="star">*</span></h6>
                        <input type="text" className="form-control" ref={refTeamPosition} maxLength={250} />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <h6>{prop.lang === 'en' ? 'Proportion':'สัดส่วนการดำเนิน โครงการวิจัย'} <span className="star">*</span></h6>
                        <input type="text" className="form-control" ref={refTeamProportion} maxLength={250} />
                    </div>
                </div>

                <div className="col-12">
                    <div className="form-group">
                        <h6>{prop.lang === 'en' ? 'Address':'ที่อยู่'} <span className="star">*</span></h6>
                        <input type="text" className="form-control" ref={refTeamAddress} maxLength={250} />
                    </div>
                </div>
                <div className="col-xl-6">
                    <div className="form-group">
                        <h6>{prop.lang === 'en' ? 'Email':'อีเมล'} <span className="star">*</span></h6>
                        <input type="text" className="form-control" ref={refTeamEmail} maxLength={250} />
                    </div>
                </div>
                <div className="col-xl-6">
                    <div className="form-group">
                        <h6>{prop.lang === 'en' ? 'Phone':'เบอร์โทร'} <span className="star">*</span></h6>
                        <input type="text" className="form-control" ref={refTeamPhone} maxLength={10} />
                    </div>
                </div>

                <div className="col-12">
                    <div className="form-group">
                        <h6>{prop.lang === 'en' ? 'Expertise':'ความชำนาญ/ความสนใจพิเศษ'}</h6>
                        <input type="text" className="form-control" ref={refTeamExpertise} maxLength={250} />
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-group">
                        <h6>{prop.lang === 'en' ? 'Responsibility':'ความรับผิดชอบต่อแผนงาน/โครงการอื่น ๆ ที่อยู่ระหว่างดำเนินการ'}</h6>
                        <input type="text" className="form-control" ref={refTeamResponsibility} maxLength={250} />
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-group">
                        <h6>H-index</h6>
                        <input type="text" className="form-control" ref={refTeamHindex} maxLength={250} />
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-group">
                        <h6>Citation</h6>
                        <input type="text" className="form-control" ref={refTeamCitation} maxLength={250} />
                    </div>
                </div>

                <div className="col-12 mt-4">
                    <div className="buttons gap-15 py-0">
                        <button className="btn btn-xs btn-green" type="button" onClick={onTeamSubmit}>
                            {prop.lang === 'en' ? 'Save':'บันทึก'}
                        </button>
                        <button className="btn btn-xs btn-gray me-auto" type="button" onClick={onTeamCancel}>
                            {prop.lang === 'en' ? 'Cancel':'ยกเลิก'}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
} 